import { ChangeEvent, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAdStudies from '../../../App/hooks/useAdStudies';
import SelectInput from '../../../components/Forms/SelectInput';
import { actionItems } from '../../folders/constants';

interface IAdStudyActionSelectProps {
  count: number;
  folder?: IFolder;
  adStudy: AdStudiesValuesForAd | null;
}
function AdStudyActionSelect({ count, folder, adStudy }: IAdStudyActionSelectProps) {
  const navigate = useNavigate();
  const [selectedAction, setSelectedAction] = useState<string>('');

  const { deleteAdStudies, moveAdStudies } = useAdStudies({});

  useEffect(() => {
    if (count === 0) {
      setSelectedAction('');
    }
  }, [count]);

  const dynamicActionList = () => {
    return count > 1 ? actionItems.filter((e) => e.value !== 'edit') : actionItems;
  };

  const handleActionChange = (e: ChangeEvent<HTMLSelectElement>) => {
    if (folder) {
      switch (e.target.value) {
        case 'edit':
          if (adStudy) {
            navigate(`/creation-annonce-dossier/${folder.id}/${adStudy.id}`);
          }
          break;
        case 'move':
          moveAdStudies(folder.idIri as string);
          break;
        case 'delete':
          deleteAdStudies(folder.idIri as string);
          break;
        default:
          break;
      }
      setSelectedAction(e.target.value);
    }
  };
  return (
    <SelectInput
      name="action"
      label="Actions"
      nameKey="text"
      value={selectedAction}
      disabled={count === 0}
      handleChange={handleActionChange}
      items={dynamicActionList()}
    />
  );
}

export default AdStudyActionSelect;
